import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-088e2c45"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-font-size medium"
}
const _hoisted_2 = {
  key: 1,
  class: "items-in-line"
}
const _hoisted_3 = { class: "items-in-line" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "medium mini-messenger__header-hidden" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "mini-messenger__header-info" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "items-in-line gap--5" }
const _hoisted_18 = {
  key: 0,
  class: "mini-messenger__main-container"
}
const _hoisted_19 = { class: "mini-messenger__main-container-messages" }
const _hoisted_20 = {
  key: 1,
  class: "mini-messenger__dialogs"
}
const _hoisted_21 = {
  key: 0,
  class: "center mini-messenger__main-container-messages"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "mini-messenger__dialogs-info"
}
const _hoisted_24 = { class: "medium items-in-line flex-start textHidden" }
const _hoisted_25 = { class: "items-in-line flex-start" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "medium items-in-line flex-start" }
const _hoisted_28 = { class: "items-in-line flex-start" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "medium items-in-line flex-start" }, "Чат с администрацией", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "mini-messenger__dialogs-date" }
const _hoisted_33 = {
  key: 2,
  class: "mini-messenger__main-container"
}
const _hoisted_34 = {
  key: 1,
  class: "mini-messenger__main-container-messages"
}

import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { MessagesFromChanelType } from '@/api/chat/types';
import { ChatComponent } from '@/components';
import { MiniMessengerType } from '@/types/MessangerTypes';
import { useChatStore } from '@/store/modules/chat';
import { useUserStore } from '@/store/modules/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniMessenger',
  props: /*#__PURE__*/_mergeModels({
    isShowAllMessagesLoading: { type: Boolean },
    isLoadingChatByHouseId: { type: Boolean },
    isSendMessageLoading: { type: Boolean },
    allMessages: {},
    chatInfo: {},
    miniMessengerInfo: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels([
  'showAllChats',
  'getMessagesByLandId',
  'getMessagesByChannelId',
  'sendMessage',
], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const isOpenBlock = computed((): boolean => {
  return !useChatStore().miniMessenger.isHidden;
});
const cardId = computed((): number | undefined => {
  return useChatStore().miniMessenger.landId;
});
const isShowAllMessages = ref(false);

const props = __props;

const emit = __emit;

// eslint-disable-next-line no-undef
const message = _useModel<string | undefined>(__props, "modelValue");
const changeChat = (chat: MessagesFromChanelType) => {
  emit('getMessagesByChannelId', chat.id);
  isShowAllMessages.value = !isShowAllMessages.value;
};
const sendMessage = async () => {
  emit('sendMessage');
};

const showAllMessages = async () => {
  isShowAllMessages.value = true;
  emit('showAllChats');
};

watch(isOpenBlock, isOpen => {
  if (useAppStore().getWindowWidth() <= 600) {
    document.body.classList[isOpen ? 'add' : 'remove']('overflow-hidden');
  }
});

watch(cardId, () => {
  if (cardId.value) {
    isShowAllMessages.value = false;
    emit('getMessagesByLandId', cardId.value);
  }
});
onBeforeUnmount(() => {
  if (useAppStore().getWindowWidth() <= 600) {
    document.body.classList.remove('overflow-hidden');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_unref(useChatStore)().miniMessenger.show)
    ? (_openBlock(), _createBlock(_component_base_card, {
        key: 0,
        class: _normalizeClass([{ isOpenBlock: isOpenBlock.value }, "mini-messenger"]),
        "full-width-mobile": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([{ isOpenBlock: isOpenBlock.value }, "mini-messenger__header"])
          }, [
            (isShowAllMessages.value || !isOpenBlock.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Сообщения "))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_base_icon, {
                    class: "xl-scale",
                    clickable: "",
                    "font-size": "28",
                    name: "arrow_back",
                    onClick: showAllMessages
                  }),
                  _withDirectives(_createElementVNode("div", _hoisted_3, [
                    (_ctx.chatInfo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createVNode(_component_base_image, {
                            src: _ctx.chatInfo?.type === 10 ? _ctx.chatInfo?.more?.house?.images[0] : undefined,
                            "border-radius": "",
                            cover: "",
                            height: "36",
                            name: "img",
                            width: "50"
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createVNode(_component_base_image, {
                            src: _ctx.miniMessengerInfo?.more?.house?.images[0],
                            "border-radius": "",
                            cover: "",
                            height: "36",
                            name: "img",
                            width: "50"
                          }, null, 8, ["src"])
                        ])),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_6, [
                        (_ctx.chatInfo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              (_ctx.chatInfo.type === 10)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.chatInfo?.more.house.address), 1))
                                : (_ctx.chatInfo.more.id !== _unref(useUserStore)().user?.id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.chatInfo.more.name), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "Чат с администрацией"))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.miniMessengerInfo?.more.house.address), 1))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.chatInfo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              (_ctx.chatInfo.type === 10)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString((+_ctx.chatInfo?.more.house.price).toLocaleString() || '-') + " ₽", 1))
                                : (_ctx.chatInfo.more.id !== _unref(useUserStore)().user?.id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.chatInfo.more.id), 1))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.miniMessengerInfo?.more.house.price.toLocaleString() || '-') + " ₽ ", 1))
                      ])
                    ])
                  ], 512), [
                    [_vShow, !_ctx.isLoadingChatByHouseId]
                  ])
                ])),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: { name: 'profile', params: { id: 'chat' } },
                class: "none-Mobile",
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, {
                    class: "xl-scale",
                    "font-size": "28",
                    name: "open_in_new"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_base_icon, {
                class: _normalizeClass([{ transform: !isOpenBlock.value }, "mini-messenger__header-icon"]),
                clickable: "",
                "font-size": "32",
                name: "expand_more",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(useChatStore)().toggleMiniMessenger(isOpenBlock.value)))
              }, null, 8, ["class"]),
              _createVNode(_component_base_icon, {
                class: _normalizeClass([{ transform: !isOpenBlock.value }, "mini-messenger__header-mobile-icon"]),
                clickable: "",
                "font-size": "32",
                name: "close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(useChatStore)().closeMiniMessenger()))
              }, null, 8, ["class"])
            ])
          ], 2),
          _createVNode(_component_base_divider),
          (_ctx.isLoadingChatByHouseId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_base_spinner, {
                    size: 50,
                    color: "#009D3E"
                  })
                ])
              ]))
            : (isShowAllMessages.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_ctx.isShowAllMessagesLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_component_base_spinner, {
                          size: 50,
                          color: "#009D3E"
                        })
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allMessages, (message) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: message.id,
                          class: "mini-messenger__dialogs-item",
                          onClick: ($event: any) => (changeChat(message))
                        }, [
                          _createVNode(_component_base_image, {
                            src: message.type === 10 ? message.more.house.images[0] : undefined,
                            "border-radius": "",
                            cover: "",
                            height: "50",
                            name: "ava",
                            width: "50"
                          }, null, 8, ["src"]),
                          (message.type === 10)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                _createElementVNode("span", _hoisted_24, _toDisplayString(message.more.house.address), 1),
                                _createElementVNode("span", _hoisted_25, _toDisplayString((+message.more.house.price).toLocaleString()) + " ₽", 1)
                              ]))
                            : (message.more.id !== _unref(useUserStore)().user?.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(message.more.name), 1),
                                  _createElementVNode("span", _hoisted_28, "id: " + _toDisplayString(+message.more.id), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31)),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(new Date(message.created_at).toLocaleString()), 1)
                        ], 8, _hoisted_22))
                      }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (_ctx.chatInfo?.messages?.length)
                    ? (_openBlock(), _createBlock(_unref(ChatComponent), {
                        key: 0,
                        messages: _ctx.chatInfo.messages,
                        withAva: false,
                        class: "mini-messenger__main-container-chat"
                      }, null, 8, ["messages"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createVNode(_component_base_icon, {
                          color: "#CBC8D9",
                          "font-size": "50",
                          name: "chat"
                        })
                      ])),
                  (isOpenBlock.value)
                    ? (_openBlock(), _createBlock(_component_base_form, {
                        key: 2,
                        class: "mini-messenger__main-container-dialog-footer"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_textarea, {
                            modelValue: message.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
                            disabled: _ctx.isLoadingChatByHouseId,
                            styleType: 'light',
                            label: "Написать сообщение",
                            "max-height": "150",
                            withScroll: ""
                          }, null, 8, ["modelValue", "disabled"]),
                          _createVNode(_component_base_icon, {
                            color: message.value?.length ? '#969696' : 'rgba(150,150,150,0.5)',
                            disabled: message.value?.length <= 0,
                            class: "xl-scale",
                            clickable: "",
                            "font-size": "28",
                            name: "send",
                            onClick: sendMessage
                          }, null, 8, ["color", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})